/**
 * External dependencies
 */
import React from 'react';
import { Box } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import ButtonGroup from 'components/button-group';
import Button from 'components/button';

/**
 * Style dependencies
 */
import './styles.scss';

const ResourceListPagination = ({ currentPage, isRequesting, totalItems, limit, onPageSwitch }) => {
    const canGoBack = currentPage >= 2;
    const canGoForward = currentPage * limit < totalItems;


    console.log()
    const goForward = () => {
        onPageSwitch({ page: currentPage + 1 });
    };

    const goBack = () => {
        onPageSwitch({ page: currentPage - 1 });
    };

    return (
        <Box alignItems='center' justifyContent='center' display='flex'>
            <ButtonGroup>
                <Button onClick={goBack} disabled={!canGoBack || isRequesting}>
                    back
                </Button>
                <Button onClick={goForward} disabled={!canGoForward || isRequesting}>
                    forward
                </Button>
            </ButtonGroup>
        </Box>
    );
};

export default ResourceListPagination;
